import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelFulfillments: {
    description: 'cancel fulfillment modal header text',
    defaultMessage: 'Cancel {count, plural, one {Fulfillment} other {Fulfillments}}',
    id: 'Cnm1LI',
  },
  cancelFulfillmentBlurb: {
    description: 'cancel fulfillments explanation',
    defaultMessage:
      "A request to cancel the {count, plural, one {fulfillment} other {fulfillments}} will be sent to the appropriate provider. Cancellation is subject to the current fulfillment status and your provider's specific policies.",
    id: 'AO/vhE',
  },
  cancelFulfillmentConfirm: {
    description: 'cancel fulfillments confirmation text',
    defaultMessage: 'To request cancellation of the selected {count, plural, one {fulfillment} other {fulfillments}}, choose Continue',
    id: 'bzCxX0',
  },
  orderNumber: {
    description: 'cancel fulfillment result table, order number column header',
    defaultMessage: 'Order #',
    id: 'KY4WCB',
  },
  resultsHeader: {
    description: 'stop fulfillment header text',
    defaultMessage: 'Results',
    id: 'h1eTB4',
  },
  result: {
    description: 'cancel fulfillment result table, result column header',
    defaultMessage: 'Result',
    id: 'NweV41',
  },
  cancelled: {
    description: 'cancel status text',
    defaultMessage: 'Cancellation requested. Order moved to Awaiting Shipment.',
    id: 'sO6pRt',
  },
  errored: {
    description: 'errored status text',
    defaultMessage: 'Ignored. Cancel not allowed by fulfillment partner.',
    id: 'KWjzhQ',
  },
  cancelButton: {
    description: 'cancel button text',
    defaultMessage: 'Cancel',
    id: 'E2qQyg',
  },
  continueButton: {
    description: 'continue button text',
    defaultMessage: 'Continue',
    id: 'E/xVtY',
  },
  requestError: {
    description: 'try again error message when cancelling fulfillments',
    defaultMessage: 'Error trying to cancel fulfillments. Please try again.',
    id: 'ow74z1',
  },
  dontCancelFulfillment: {
    description: 'abort cancel fulfillment button text',
    defaultMessage: "Don't Cancel Fulfillment",
    id: 'IGq91M',
  },
});
